import type { WorkspaceDto } from "@/api/workspace/types";

import { createContext } from "react";

export interface WorkspaceContextProps {
  workspace: WorkspaceDto | null;
  workspaceLoading: boolean;
  workspaceError: Error | null;
  // New properties
  availableWorkspaces: WorkspaceDto[];
  availableWorkspacesLoading: boolean;
  switchWorkspace: (workspaceId: string) => void;
  workspaceRefresh: () => Promise<any>;
  currentWorkspaceId: string | null;
}

export const WorkspaceContext = createContext<WorkspaceContextProps>({
  workspace: null,
  workspaceLoading: true,
  workspaceError: null,
  // Default values for new properties
  availableWorkspaces: [],
  availableWorkspacesLoading: true,
  switchWorkspace: () => {},
  workspaceRefresh: async () => {},
  currentWorkspaceId: null,
});
